<template>
  <div class="dayplan-table-container w-100">

    <!--
    <DayplannerFlowchart
      v-for="day in view_date_range"
      :key="day.$key"
      ref="day_flowchart"
      :view-date="day.view_date" />
    -->

    <!-- TODO: move to component? -->

    <div class="goal-table">

      <div class="goal-table-heading">
        <div class="goal-table-row">
          <div class="goal-table-head">
            Goal
          </div>
          <div
            class="goal-table-head"
            v-for="day in viewDateRange"
            :key="day.$key">
            {{day.view_date|longDateWithDay}}
          </div>
        </div>
      </div>

      <!-- TODO: cluster by category -->
      <!-- TODO: getUserGoalByCategoryId(categoryId) -->
      <!-- TODO: sort by sortidx -->
      <!-- TODO: hide deleted -->

      <div class="goal-table-body">
        <div
          class="goal-table-row"
          v-for="goal in user_goal_settings.itemsAsArray()"
          :key="goal.$key">
          <div class="goal-table-cell goal-table-column-head">

            <!-- <h5>{{goal.cachedName}}</h5> -->
            <!-- <h5>{{goal_meta_map[ goal.$id ].picture}}</h5> -->
            <h5>{{goal_meta_map[ goal.$id ].$state.name}}</h5>

            <InlineGoalCardMinimal
              :goal="goal_meta_map[ goal.$id ]"
              @click.native="onClickGoalCard( goal.$id )" />

            <!-- {{goal.isFavorite}} -->
            <!-- {{goal.$id}} -->

            <!-- <pre class="mini-pre">{{goal}}</pre> -->
            <!-- <pre class="mini-pre">{{goal_meta_map[ goal.$id ]}}</pre> -->
          </div>
          <div
            class="goal-table-cell"
            v-for="day in viewDateRange"
            :key="day.$key">

            <GoalDaySummary
              :goal-id="goal.$id"
              :view-date="day.view_date" />
            <!-- {{goal.$id}} vs. {{day.$key}} -->

          </div>
        </div>
      </div>
    </div>

    <!--
    <div class="goal-table">
      <div class="goal-table-heading">
        <div class="goal-table-row">
          <div class="goal-table-head">head1</div>
          <div class="goal-table-head">head2</div>
        </div>
      </div>
      <div class="goal-table-body">
        <div class="goal-table-row">
          <div class="goal-table-cell">cell1_1</div>
          <div class="goal-table-cell">cell2_1</div>
        </div>
        <div class="goal-table-row">
          <div class="goal-table-cell">cell1_2</div>
          <div class="goal-table-cell">cell2_2</div>
        </div>
        <div class="goal-table-row">
          <div class="goal-table-cell">cell1_3</div>
          <div class="goal-table-cell">cell2_3</div>
        </div>
      </div>
      <div class="goal-table-foot">
        <div class="goal-table-row">
          <div class="goal-table-cell">foot1</div>
          <div class="goal-table-cell">foot2</div>
          <div class="goal-table-cell">foot3</div>
          <div class="goal-table-cell">foot4</div>
        </div>
      </div>
    </div>
    -->
  </div>
</template>

<script>

// TODO: Only show one goal

// import { mapGetters, mapActions, mapMutations } from "vuex";
import { mapReady } from '@/api/misc'
// import GoalManagementMixin from "@/components/Mixins/GoalManagement"
import GoalDaySummary from '@/components/TodayPage/Elements/GoalDaySummary'

// TODO: View mode 1: Zusammenfassung (Stunden geplant, stunden geabreitet)
// TODO: View mode 2: Alle tasks
// TODO: Show row for each commitment?

// TODO: Always show_reduced_dayplan in talbe view
// TODO: Bei wechsel in table auf ganze Woche umschalten

export default {
  // mixins: [ GoalManagementMixin ],
  props: {
    viewDateRange: {
      required: true
    }
  },
  computed: {
    ...mapReady("goals", "commitments", "optimizer_input")
  },
  methods: {
    onClickGoalCard( goalId ) {
      console.log("onClickGoalCard", goalId)
    },
  },
  components: {
    GoalDaySummary,
  }
};
</script>

<style>
/* Source: DivTable.com */
/* stylelint-disable no-duplicate-selectors */

.goal-table { display: table; }
.goal-table-row { display: table-row; }
.goal-table-cell,
 .goal-table-head { display: table-cell; }
.goal-table-heading { display: table-header-group; }
.goal-table-foot { display: table-footer-group; }
.goal-table-body { display: table-row-group; }

.goal-table {
  border: 2px solid #FFFFFF;
  width: 100%;
  /*text-align: center;*/
  border-collapse: collapse;
}
.goal-table .goal-table-cell,
.goal-table .goal-table-head {
  border: 1px solid #FFFFFF;
  padding: 3px 4px;
}
.goal-table .goal-table-body .goal-table-cell {
  font-size: 13px;
}
.goal-table .goal-table-cell:nth-child(even) {
  background: #FFFFFFB0;
}
.goal-table .goal-table-cell:nth-child(odd) {
  background: #AAAAAAB0;
}
.goal-table .goal-table-column-head {
  /*background: #FFFFFFB0;*/
  background: #666666B0 !important;
  text-align: center;
  color: white;
  vertical-align: middle;
}
.goal-table .goal-table-heading {
  background: #FFFFFFB0;
  border-bottom: 4px solid #333333;
}
.goal-table .goal-table-heading .goal-table-head {
  font-size: 15px;
  font-weight: bold;
  color: #333333;
  text-align: center;
  border-left: 2px solid #333333;
  min-width: 250px;
}
.goal-table .goal-table-heading .goal-table-head:first-child {
  border-left: none;
}
.goal-table .goal-table-foot {
  font-weight: bold;
  color: #333333;
  border-top: 4px solid #333333;
  font-size: 14px;
}
</style>
